import React from "react";

export default function NotFound() {
  return (
    <div className="notFound">
      <img
        src="https://i.giphy.com/media/3o7aCTPPm4OHfRLSH6/giphy.webp"
        alt="bob"
      />
      <p>Don't worry!. Bob is really good with navigation</p>
    </div>
  );
}
